import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import { type FinderApplicationModuleEmailContentsSetting } from '../../../../api/types';

export enum HeaderTabs {
    Vehicles = 'vehicles',
    FinanceProducts = 'financeProducts',
    MainDetails = 'mainDetails',
    Email = 'email',
}

export type FinderApplicationEmailFormValues = {
    submitOrder: FinderApplicationModuleEmailContentsSetting['submitOrder'] & {
        introImage?: File | UploadFileWithPreviewFormDataFragment;
    };
    reminderEmail: FinderApplicationModuleEmailContentsSetting['reminderEmail'] & {
        introImage?: File | UploadFileWithPreviewFormDataFragment;
    };
};

export type FinderApplicationModuleCounterKey =
    | 'applicationCounter'
    | 'reservationCounter'
    | 'leadCounter'
    | 'appointmentCounter'
    | 'insuranceCounter';
